export default "__VITE_ASSET__COpfUSEy__"